<template>
  <div>
    <div v-if="!isUpload">
      <!-- Header -->
      <v-card
        variant="outlined"
        class="laudo-clinico-card"
      >
        <div class="premium-header px-4 py-3">
          <v-row
            no-gutters
            align="center"
            class="flex-nowrap"
          >
            <div class="header-title">
              <v-icon
                color="grey-darken-3"
                class="mr-2"
              >
                description
              </v-icon>
              <span class="text-h6 font-weight-medium text-grey-darken-3">Laudo Clínico</span>
            </div>
            
            <v-spacer />
            
            <!-- Controles do Header -->
            <div class="header-controls d-flex align-center">
              <!-- Busca de Modelos -->
              <v-autocomplete
                v-model="modelo"
                :items="modelos"
                :loading="isLoading"
                density="compact"
                variant="outlined"
                item-title="nome"
                item-value="_id"
                label="Buscar Modelos"
                placeholder="Digite para buscar"
                prepend-inner-icon="search"
                return-object
                hide-details
                class="modelos-autocomplete"
                style="width: 280px;"
                @update:model-value="abrirDialogAplicarModelo"
              />

              <!-- Botões de Ação -->
              <div class="action-buttons d-flex align-center ml-4">
                <v-menu location="bottom">
                  <template #activator="{ props }">
                    <v-btn 
                      v-bind="props"
                      icon 
                      variant="text"
                      class="action-btn"
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      :disabled="!idMedelo"
                      @click="clear"
                    >
                      <template #prepend>
                        <v-icon>cleaning_services</v-icon>
                      </template>
                      <v-list-item-title>Limpar modelo</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :disabled="!!idMedelo || content.length < 8"
                      @click="dialogNovoModelo = true"
                    >
                      <template #prepend>
                        <v-icon>note_add</v-icon>
                      </template>
                      <v-list-item-title>Novo modelo</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :disabled="!idMedelo || content.length < 8"
                      @click="dialogEditarModelo = true"
                    >
                      <template #prepend>
                        <v-icon>edit</v-icon>
                      </template>
                      <v-list-item-title>Editar modelo</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </v-row>
        </div>

        <v-divider class="border-grey-lighten-2" />

        <!-- Conteúdo Principal -->
        <v-container
          fluid
          class="pa-4 mt-5"
        >
          <!-- Editor -->
          
          <PittapEditor 
            v-show="!isImprime" 
            v-model="content" 
            :editable="true"
            :placeholder="'Digite o laudo clínico aqui...'"
            class="editor-container"
            @update:model-value="onEditorUpdate"
          />
        </v-container>



        <!-- Alert -->
        <v-alert 
          v-show="alert.visible" 
          density="compact" 
          :type="alert.type"
          class="ma-4"
        >
          {{ alert.message }}
        </v-alert>
      </v-card>

      <v-dialog
        v-model="dialogAplicarModelo"
        width="420"
      >
        <v-card variant="outlined" style="background-color: rgb(var(--v-theme-surface)); color: rgb(var(--v-theme-on-surface));">
          <v-card-title>Aplicar modelo</v-card-title>
          <v-card-text>
            Escolha como deseja inserir o modelo
            <strong>{{ modeloPendente?.nome || '' }}</strong>.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="cancelarAplicacaoModelo">Cancelar</v-btn>
            <v-btn variant="outlined" @click="aplicarModelo('substituir')">Substituir</v-btn>
            <v-btn color="primary" variant="flat" @click="aplicarModelo('acrescentar')">Acrescentar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Visualização de Laudo Liberado -->
      <v-card
        v-if="status === 'L'"
        variant="outlined"
        class="mt-4 laudo-liberado-card"
      >
        <v-card-actions class="premium-header">
          <v-btn 
            color="grey-darken-2" 
            variant="outlined" 
            class="action-btn"
            @click="voltar"
          >
            <v-icon left>
              keyboard_return
            </v-icon>
            Voltar
          </v-btn>
        </v-card-actions>
        <v-divider class="border-grey-lighten-2" />
        <v-card-text class="pa-6">
          <div
            class="laudo-content"
            v-html="content"
          />
        </v-card-text>
      </v-card>
    </div>

    <!-- Diálogo de Confirmação de Liberação -->
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 text-white bg-warning py-4 d-flex align-center">
          <v-icon
            left
            color="white"
          >
            warning
          </v-icon>
          Confirmação de Liberação
        </v-card-title>

        <v-card-text class="pa-6 text-body-1">
          <div class="d-flex align-center mb-4">
            <v-icon
              color="warning"
              class="mr-3"
            >
              info
            </v-icon>
            <span class="font-weight-medium">Atenção: Esta ação é irreversível</span>
          </div>
          <p class="text-grey-darken-2">
            Após a liberação do laudo, não será possível realizar alterações.
            Certifique-se de revisar todas as informações antes de concluir o processo.
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn 
            color="grey-darken-2" 
            variant="outlined" 
            class="action-btn"
            @click="dialog = false"
          >
            <v-icon left>
              cancel
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn 
            color="warning" 
            variant="flat" 
            class="action-btn"
            @click="idLaudo == null ? salvarLaudo() : editarLaudo()"
          >
            <v-icon left>
              check_circle
            </v-icon>
            Confirmar Liberação
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Novo Modelo -->
    <v-dialog
      v-model="dialogNovoModelo"
      width="900"
      persistent
    >
      <v-card class="rounded-lg gm-dialog">
        <v-card-title class="text-h5 gm-dialog-header py-3 d-flex align-center">
          <v-icon
            left
            color="grey-darken-2"
          >
            add_circle
          </v-icon>
          <span class="ml-2">Cadastrar Novo Modelo</span>
        </v-card-title>

        <v-card-text class="pa-6 gm-dialog-content">
          <v-text-field
            v-model="tituloModelo"
            label="Título do Modelo"
            variant="outlined"
            :rules="[v => !!v || 'Título é obrigatório']"
            color="grey-darken-3"
            density="compact"
            class="mb-4"
          />
          
          <v-card
            variant="outlined"
            class="editor-modelo-card"
          >
            <v-card-title class="text-subtitle-2 font-weight-medium d-flex align-center text-grey-darken-3 py-3">
              <v-icon
                color="grey-darken-3"
                size="small"
                class="mr-2"
              >
                description
              </v-icon>
              Conteúdo do Modelo
            </v-card-title>
            <v-divider class="border-grey-lighten-2" />
            <v-card-text class="pa-0">
              <PittapEditor 
                v-model="contentModelo" 
                :editable="true"
                :placeholder="'Digite o conteúdo do modelo aqui...'"
                class="editor-container"
              />
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 gm-dialog-actions">
          <v-spacer />
          <v-btn 
            color="grey-darken-2" 
            variant="text" 
            class="action-btn"
            @click="fecharDialogoNovoModelo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="loadModelos"
            class="action-btn"
            variant="flat"
            :disabled="!tituloModelo || !contentModelo"
            @click="cadastrarModeloLaudo"
          >
            <v-icon left>
              save
            </v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Editar Modelo -->
    <v-dialog
      v-model="dialogEditarModelo"
      width="900"
      persistent
    >
      <v-card class="rounded-lg gm-dialog">
        <v-card-title class="text-h5 gm-dialog-header py-3 d-flex align-center">
          <v-icon
            left
            color="grey-darken-2"
          >
            edit
          </v-icon>
          <span class="ml-2">Editar Modelo</span>
        </v-card-title>

        <v-card-text class="pa-6 gm-dialog-content">
          <v-text-field
            v-model="tituloModelo"
            label="Título do Modelo"
            variant="outlined"
            :rules="[v => !!v || 'Título é obrigatório']"
            color="grey-darken-3"
            density="compact"
            class="mb-4"
          />
          
          <v-card
            variant="outlined"
            class="editor-modelo-card"
          >
            <v-card-title class="text-subtitle-2 font-weight-medium d-flex align-center text-grey-darken-3 py-3">
              <v-icon
                color="grey-darken-3"
                size="small"
                class="mr-2"
              >
                description
              </v-icon>
              Conteúdo do Modelo
            </v-card-title>
            <v-divider class="border-grey-lighten-2" />
            <v-card-text class="pa-0">
              <PittapEditor 
                v-model="contentModelo" 
                :editable="true"
                :placeholder="'Digite o conteúdo do modelo aqui...'"
                class="editor-container"
              />
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 gm-dialog-actions">
          <v-spacer />
          <v-btn 
            color="grey-darken-2" 
            variant="text" 
            class="action-btn"
            @click="fecharDialogoEditarModelo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="action-btn"
            variant="flat"
            :disabled="!tituloModelo || !contentModelo"
            @click="atualizarModeloLaudo"
          >
            <v-icon left>
              save
            </v-icon>
            Salvar Alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, defineProps, defineEmits, defineExpose } from 'vue'
import medicoService from '../../../services/medico.service'
import { useStore } from 'vuex'
import PittapEditor from './tiptapEditor.vue'

// Props e Emits permanecem os mesmos
const props = defineProps({
  paciente: Object,
  consulta: Object,
  userAux: Object
})

const emit = defineEmits(['voltar'])
const store = useStore()

// Refs (mantidas as mesmas)
const isImprime = ref(false)
const dialogNovoModelo = ref(false)
const dialogEditarModelo = ref(false)
const dialogAplicarModelo = ref(false)
const idLaudo = ref(null)
const loadLaudo = ref(false)
const content = ref('')
const contentModelo = ref('')
const isUpload = ref(false)
const modelo = ref(null)
const modeloAtivo = ref(null)
const modeloPendente = ref(null)
const dialog = ref(false)
const idExamesOs = ref(null)
const isLoading = ref(false)
const modelos = ref([])
const loadSave = ref(false)
const loadModelos = ref(false)
const status = ref('X')
const alert = ref({ visible: false, message: '', type: '' })
const tituloModelo = ref('')
const idMedelo = ref(null)
const user = ref({})

const campoLaudoTemConteudo = (conteudo = content.value) => {
  const texto = (conteudo || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, '')
    .trim()
  return texto.length > 0
}

// Métodos (mantidos os mesmos, apenas atualizei os nomes das classes CSS se necessário)
const abrirDialogAplicarModelo = (valor) => {
  if (!valor) return
  modeloPendente.value = valor
  if (!campoLaudoTemConteudo()) {
    aplicarModelo('substituir')
  } else {
    dialogAplicarModelo.value = true
    modelo.value = null
  }
}

const aplicarModelo = (modo = 'acrescentar') => {
  if (!modeloPendente.value) return
  const item = modeloPendente.value
  modeloAtivo.value = item
  content.value = modo === 'substituir'
    ? item.descricao
    : (content.value ? `${content.value}<p></p>${item.descricao}` : item.descricao)
  tituloModelo.value = item.nome
  idMedelo.value = item._id
  cancelarAplicacaoModelo()
}

const cancelarAplicacaoModelo = () => {
  dialogAplicarModelo.value = false
  modeloPendente.value = null
  modelo.value = null
}

const clear = () => {
  content.value = ''
  modelo.value = null
  modeloAtivo.value = null
  tituloModelo.value = ''
  idMedelo.value = null
}

const buscarModeloLaudo = () => {
  isLoading.value = true
  medicoService.medico.buscarModeloLaudo(user.value.id)
    .then(response => {
      if (response.status === 200) {
        modelos.value = response.data.modelos || response.data
      }
    })
    .catch(error => {
      console.error('Erro ao buscar modelos:', error)
      showAlert('Erro ao carregar modelos', 'error')
    })
    .finally(() => {
      isLoading.value = false
    })
}

const cadastrarModeloLaudo = () => {
  if (!tituloModelo.value.trim()) {
    showAlert('Título do modelo é obrigatório', 'error')
    return
  }

  loadModelos.value = true
  const modeloData = {
    idUsuario: user.value.id,
    nome: tituloModelo.value,
    descricao: contentModelo.value || content.value,
    tipo: 'LAUDO'
  }

  medicoService.medico.cadastrarModeloLaudo(modeloData)
    .then(response => {
      if (response.status === 200) {
        showAlert('Modelo cadastrado com sucesso!', 'success')
        fecharDialogoNovoModelo()
        buscarModeloLaudo()
      }
    })
    .catch(error => {
      console.error('Erro ao cadastrar modelo:', error)
      showAlert('Erro ao cadastrar modelo', 'error')
    })
    .finally(() => {
      loadModelos.value = false
    })
}

const atualizarModeloLaudo = () => {
  if (!tituloModelo.value.trim() || !idMedelo.value) {
    showAlert('Dados incompletos para atualização', 'error')
    return
  }

  loadModelos.value = true
  const modeloData = {
    idUsuario: user.value.id,
    nome: tituloModelo.value,
    descricao: contentModelo.value || content.value,
    _id: idMedelo.value
  }

  medicoService.medico.cadastrarModeloLaudo(modeloData)
    .then(response => {
      if (response.status === 200) {
        showAlert('Modelo atualizado com sucesso!', 'success')
        fecharDialogoEditarModelo()
        buscarModeloLaudo()
      }
    })
    .catch(error => {
      console.error('Erro ao atualizar modelo:', error)
      showAlert('Erro ao atualizar modelo', 'error')
    })
    .finally(() => {
      loadModelos.value = false
    })
}

const fecharDialogoNovoModelo = () => {
  dialogNovoModelo.value = false
  tituloModelo.value = ''
  contentModelo.value = ''
}

const fecharDialogoEditarModelo = () => {
  dialogEditarModelo.value = false
  tituloModelo.value = ''
  contentModelo.value = ''
  idMedelo.value = null
}

const buscarLaudoClinicoPorIdExamesOS = () => {
  const idExameOS = props.consulta.idexamesos || props.consulta.idExamesOS

  if (!idExameOS) {
    console.error('ID do exame não encontrado')
    return
  }

  loadLaudo.value = true
  medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExameOS)
    .then(response => {
      if (response.status === 200 && response.data) {
        idExamesOs.value = response.data.idExamesOS
        content.value = response.data.descricaoLaudo || ''
        status.value = response.data.status || 'X'
        idLaudo.value = response.data.id
      }
    })
    .catch(error => {
      console.error('Erro ao buscar laudo:', error)
    })
    .finally(() => {
      loadLaudo.value = false
    })
}

const editarLaudo = () => {
  dialog.value = false
  loadSave.value = true

  medicoService.medico.editarLaudoClinico(
    idExamesOs.value,
    content.value,
    status.value === 'LX' ? 'L' : 'X'
  )
    .then(response => {
      if (response.status === 200) {
        showAlert('Laudo editado com sucesso!', 'success', 1200, () => voltar())
      }
    })
    .catch(error => {
      console.error('Erro ao editar laudo:', error)
      showAlert('Erro ao editar laudo', 'error')
    })
    .finally(() => {
      loadSave.value = false
    })
}

const salvarLaudo = () => {
  if (props.paciente?.status === 4) {
    showAlert('Atendimento com status atendido. Não é possível cadastrar novos laudos.', 'warning')
    return
  }
  dialog.value = false
  loadSave.value = true
  const idExameOS = props.consulta.idexamesos || props.consulta.idExamesOS

  medicoService.medico.cadastrarLaudoClinico({
    idExamesOs: idExameOS,
    idPaciente: props.paciente.idPaciente,
    idEmpresa: props.userAux.idEmpresa,
    idUnidade: props.userAux.idUnidade,
    idPrestador: null,
    idUsuario: props.userAux.id,
    descricao: content.value,
    status: status.value === 'LX' ? 'L' : 'X'
  })
    .then(response => {
      if (response.status === 200) {
        idLaudo.value = response.data.id
        showAlert('Laudo cadastrado com sucesso!', 'success', 1200, () => voltar())
      }
    })
    .catch(error => {
      console.error('Erro ao salvar laudo:', error)
      showAlert('Erro ao salvar laudo', 'error')
    })
    .finally(() => {
      loadSave.value = false
    })
}

const showAlert = (message, type, timeout = 3000, callback) => {
  alert.value = { visible: true, message, type }
  setTimeout(() => {
    alert.value.visible = false
    if (callback) callback()
  }, timeout)
}

const listarModelosProntuario = () => {
  isLoading.value = true
  medicoService.medico.listarModelosProntuario('LAUDO', props.userAux.id, props.consulta.idExame)
    .then(({ status, data }) => {
      if (status === 200 && data.status !== 'error') {
        modelos.value = data
      }
    })
    .catch(error => {
      console.error('Erro ao listar modelos:', error)
    })
    .finally(() => {
      isLoading.value = false
    })
}

const voltar = () => {
  emit('voltar', true)
}

const onEditorUpdate = (value) => {
  content.value = value
}

const salvar = () => {
  if (idLaudo.value == null) {
    salvarLaudo()
  } else {
    editarLaudo()
  }
}

defineExpose({
  salvar,
  voltar
})

// Watchers (mantidos os mesmos)
watch(status, (val) => {
  if (val === 'LX') {
    dialog.value = true
  }
})

watch(dialogNovoModelo, (val) => {
  if (val) {
    contentModelo.value = content.value
    tituloModelo.value = ''
  }
})

watch(dialogEditarModelo, (val) => {
  const modeloEdicao = modeloAtivo.value || modelo.value
  if (val && modeloEdicao) {
    contentModelo.value = modeloEdicao.descricao
    tituloModelo.value = modeloEdicao.nome
  }
})

// Lifecycle
onMounted(() => {
  user.value = store.getters.usuario || props.userAux
  listarModelosProntuario()
  buscarLaudoClinicoPorIdExamesOS()
  buscarModeloLaudo()
})
</script>

<style scoped>
.laudo-clinico-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

/* Header */
.premium-header {
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  min-height: 70px;
}

.header-title {
  display: flex;
  align-items: center;
}

.header-controls {
  gap: 12px;
}

.modelos-autocomplete {
  min-width: 280px;
}

.action-buttons {
  gap: 8px;
}

.action-btn {
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

/* Cards de conteúdo */
.editor-card,
.laudo-liberado-card,
.editor-modelo-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: box-shadow 0.3s ease;
}

.editor-card:hover,
.editor-modelo-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.editor-container {
  max-height: 500px;
  min-height: 420px;
  border-radius: 8px;
  overflow-y: auto;
}

/* Estado vazio */
.empty-state {
  border: 2px dashed rgba(var(--v-theme-on-surface), 0.12);
}

/* Conteúdo do laudo liberado */
.laudo-content :deep(*) {
  max-width: 100%;
}

/* Actions Footer */
.actions-footer {
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

.left-actions,
.right-actions {
  gap: 8px;
}

.status-switch {
  margin-bottom: 0;
}

/* Responsividade */
@media (max-width: 960px) {
  .premium-header {
    min-height: 60px;
    padding: 8px 12px;
  }
  
  .header-controls {
    flex-direction: column;
    gap: 8px;
  }
  
  .modelos-autocomplete {
    width: 100%;
    min-width: auto;
  }
  
  .action-buttons {
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .premium-header {
    min-height: 56px;
    padding: 6px 8px;
  }
  
  .actions-footer {
    flex-direction: column;
    gap: 12px;
  }
  
  .left-actions,
  .right-actions {
    width: 100%;
    justify-content: center;
  }
  
  .status-switch {
    margin-right: 0;
  }
}

/* Animações suaves */
.v-card {
  transition: all 0.3s ease;
}

.v-btn {
  transition: all 0.2s ease;
}

/* Scrollbar personalizada */
.editor-container :deep(.ProseMirror) {
  scrollbar-width: thin;
  scrollbar-color: #bdbdbd #f5f5f5;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar {
  width: 6px;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 3px;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
</style>
